<template>
    <breadCrumbs title="typography" main="Ui Kits" title1="typography" />

    <div class="container-fluid">
        <div class="row">
            <headings />
            <headings2 />
            <headings3 />
        </div>
    </div>
</template>
<script>
import headings from "./headingsPage.vue"
import headings2 from "./headings2Page.vue"
import headings3 from "./headings3Page.vue"
export default {
    components: {
        headings,
        headings2,
        headings3
    }
}
</script>